export enum OverviewModalEnum {
  BillingSetup,
  AcceptCompany,
  DeclineCompany,
  DisconnectClient,
  ConnectClient,
  PayGroups,
}
